import React from "react";
import GratefulDB from "./GratefulDB";

const GratefulDBContext = React.createContext<GratefulDB>(new GratefulDB());

export const GratefulDBContextProvider = GratefulDBContext.Provider;

export default GratefulDBContext;
